import { useNavigate } from 'react-router-dom';
import DefaultButton from '../buttons/DefaultButton';
import { useAuth } from '../../../services/auth';

export default function Logout() {
    const navigate = useNavigate();
    const { logout } = useAuth();

    const handleSubmit = () => {
        logout();
        navigate('/');
    };

    return (
        <DefaultButton
            text="Log out"
            variant="ghost"
            onClick={handleSubmit}
        />
    );
}
